import React, { createContext, useContext, useEffect } from 'react';
import { useMeetingManager, useRemoteVideoTileState, useRosterState } from 'amazon-chime-sdk-component-library-react';
import { MeetingSessionStatusCode } from 'amazon-chime-sdk-js';
import { useVideoConfig } from '../video-config-provider';
import { useAttendees } from '../../../hooks/attendees';
export const SessionContext = createContext({
    attendees: [],
    currentAttendeeId: null,
    sharingAttendeeId: null,
    focusedAttendeeId: null,
});
export const SessionProvider = ({ children }) => {
    const { onSessionEnded = () => { } } = useVideoConfig();
    const meetingManager = useMeetingManager();
    const { currentAttendeeId, sharingAttendeeId, visibleAttendees, focusedAttendeeId } = useAttendees();
    useEffect(() => {
        const observer = {
            audioVideoDidStop: (sessionStatus) => {
                const sessionStatusCode = sessionStatus.statusCode();
                if ([
                    MeetingSessionStatusCode.MeetingEnded,
                    MeetingSessionStatusCode.AudioJoinedFromAnotherDevice,
                    MeetingSessionStatusCode.SignalingBadRequest, // Banned
                ].includes(sessionStatusCode)) {
                    /*
                        - You (or someone else) have called the DeleteMeeting API action in your server application.
                        - You attempted to join a deleted meeting.
                        - No audio connections are present in the meeting for more than five minutes.
                        - Fewer than two audio connections are present in the meeting for more than 30 minutes.
                        - Screen share viewer connections are inactive for more than 30 minutes.
                        - The meeting time exceeds 24 hours.
                        See https://docs.aws.amazon.com/chime/latest/dg/mtgs-sdk-mtgs.html for details.
                      */
                    onSessionEnded(sessionStatusCode);
                }
                else {
                    console.log('Stopped with a session status code: ', sessionStatusCode);
                }
            },
        };
        meetingManager.audioVideo.addObserver(observer);
        return () => {
            if (meetingManager.audioVideo) {
                meetingManager.audioVideo.removeObserver(observer);
            }
        };
    }, []);
    return (React.createElement(SessionContext.Provider, { value: { attendees: visibleAttendees, currentAttendeeId, sharingAttendeeId, focusedAttendeeId } }, children));
};
export const useSession = () => useContext(SessionContext);
export const useTileId = (attendeeId) => useRemoteVideoTileState().attendeeIdToTileId[attendeeId];
export const useExternalUserId = (attendeeId) => { var _a; return (_a = useRosterState().roster[attendeeId]) === null || _a === void 0 ? void 0 : _a.externalUserId; };
//# sourceMappingURL=session-provider.js.map